import { Modal } from "@appkit4/react-components";
import { Button } from "../../components/ReadonlyAwareInputs";
import { getGroupData, getPoaIndex } from "../../services/GroupContext";
import "./outputs.scss";

const ConfirmationModal = ({ visible, isLoading, onCancel, onClick }) => {
  const hasPreviousUnsubmittedPeriods = getGroupData()
    ?.periods_of_account?.slice(0, getPoaIndex())
    .some((period) => period?.return_status?.isSubmitted === false);

  return (
    <Modal
      initialFocus={false}
      wrapperStyle={{ zIndex: "5000" }}
      title={"⚠️ Confirm Output Generation"}
      ariaLabel={"Confirmation Modal"}
      onCancel={onCancel}
      visible={visible}
      modalStyle={{ width: "33.75rem" }}
      footer={
        <>
          <Button neverReadonly onClick={onCancel} kind="secondary">
            Cancel
          </Button>
          <Button
            neverReadonly
            kind="primary"
            loading={isLoading}
            onClick={() => {
              onClick();
            }}
          >
            Proceed
          </Button>
        </>
      }
    >
      <p style={{ marginBottom: "10px" }}>
        By generating the outputs I confirm that the calculations are finalised.
      </p>
      {hasPreviousUnsubmittedPeriods && (
        <p>
          Please note there are prior periods in the app which have not been
          marked as submitted.
        </p>
      )}
    </Modal>
  );
};

export default ConfirmationModal;
